import {
  Component,
  Input,
  HostListener,
  ElementRef,
  OnInit,
  OnDestroy
} from '@angular/core'
import { Subscription } from 'rxjs'
import { Weighing } from '../../../common/interfaces/weighing.interface'
import { ViewportService } from '../../../common/services/viewport.service'
import { ConnectivityService } from '../../../common/services/offline/connectivity.service'

@Component({
  selector: 'app-weighing-table',
  templateUrl: './weighing-table.component.html',
  styleUrls: ['./weighing-table.component.scss']
})
export class WeighingTableComponent implements OnInit, OnDestroy {
  @Input() weighings: Weighing[]
  @Input() sampleId: number

  weighingToDelete: Weighing
  activeActionDropdown: number
  activeTouchActionBar: number

  isTouchResolution: boolean
  isOnline = true

  private subscriptions = new Subscription()

  constructor(
    private elementRef: ElementRef,
    private viewportService: ViewportService,
    private connectivityService: ConnectivityService
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.viewportService.isTouchResolution.subscribe(
        (isTouchResolution: boolean) => {
          this.isTouchResolution = isTouchResolution
        }
      )
    )

    this.subscriptions.add(
      this.connectivityService.isOnline$.subscribe(online => {
        this.isOnline = online
      })
    )
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }

  toggleActionDropdown(index: number) {
    if (this.activeActionDropdown === index) {
      delete this.activeActionDropdown
    } else {
      this.activeActionDropdown = index
    }
  }

  toggleTouchActionBar(index: number) {
    if (this.activeTouchActionBar === index) {
      delete this.activeTouchActionBar
    } else {
      this.activeTouchActionBar = index
    }
  }

  @HostListener('document:click', ['$event.target'])
  onClick(target) {
    // We track clicks to close dropdown if open and click outside
    if (this.activeActionDropdown >= 0) {
      const dropdowns: NodeList =
        this.elementRef.nativeElement.querySelectorAll('.dropdown')

      let clickedOut = true
      dropdowns.forEach((d: Node) => {
        if (d.contains(target)) {
          clickedOut = false
        }
      })

      if (clickedOut) {
        delete this.activeActionDropdown
      }
    }
  }

  isEditableOffline(weighing: Weighing): boolean {
    return weighing._pendingSync === true || String(weighing.id).startsWith('temp_')
  }

  delete(weighing: Weighing): void {
    this.weighingToDelete = weighing
  }

  onDeleteCanceled() {
    delete this.weighingToDelete
  }
}
